import {Injectable} from '@angular/core';
import {AbstractSaveOneService} from '../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {MedicalRecordSportModel} from '../../api/model/medicalRecordSport.model';
import {MedicalSportSavePayload} from './payload/medicalSportSave.payload';
import {MedicalSportRepository} from './ngrx/medicalSport.repository';
import {MedicalSportDataServiceAdapter} from './ngrx/medicalSportDataService.adapter';

@Injectable()
export class MedicalSportSaveOneService
    extends AbstractSaveOneService<MedicalRecordSportModel, MedicalSportSavePayload> {

    constructor(public repository: MedicalSportRepository,
                public dataServiceAdapter: MedicalSportDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
